// extracted by mini-css-extract-plugin
export default {"container":"PcAdminPanel_container__kkbuC","cardLabel":"PcAdminPanel_cardLabel__eEmXs"};